import { Box, CssBaseline } from '@mui/material';
import { useRouter } from 'next/router';
import { ReactNode } from 'react';

import PreviewBanner from 'components/@navigation/PreviewBanner';

interface Props {
  children: ReactNode;
}

const Layout = ({ children }: Props) => {
  const { isPreview } = useRouter();

  return (
    <>
      <CssBaseline />
      {isPreview && <PreviewBanner />}
      <Box
        component="main"
        className="main-layout"
        data-version={process.env.NEXT_PUBLIC_SENTRY_RELEASE}
        sx={{
          flex: '1 auto',
          bgcolor: 'background.default',
          color: 'text.primary',
          flexDirection: 'column',
          display: 'flex',
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default Layout;
